import { styled } from '@mui/material';

interface FormFieldSetProps {
  marginBottom?: number;
}

const FormFieldSet = styled('fieldset')<FormFieldSetProps>((props) => ({
  borderRadius: 4,
  border: '1px solid #bdbdbd',
  marginBottom: props.marginBottom ?? 0,
}));

export default FormFieldSet;
